export type MarketDataAdapterErrorCode =
  | "configuration-error"
  | "http-error"
  | "invalid-response"
  | "database-error";

export class MarketDataAdapterError extends Error {
  readonly code: MarketDataAdapterErrorCode;

  constructor(code: MarketDataAdapterErrorCode, message: string, options?: ErrorOptions) {
    super(message, options);
    this.name = "MarketDataAdapterError";
    this.code = code;
  }
}

export class AdapterConfigurationError extends MarketDataAdapterError {
  constructor(message: string, options?: ErrorOptions) {
    super("configuration-error", message, options);
    this.name = "AdapterConfigurationError";
  }
}

export class AdapterHttpError extends MarketDataAdapterError {
  readonly status: number;

  constructor(status: number, message: string, options?: ErrorOptions) {
    super("http-error", message, options);
    this.name = "AdapterHttpError";
    this.status = status;
  }
}

export class AdapterValidationError extends MarketDataAdapterError {
  constructor(message: string, options?: ErrorOptions) {
    super("invalid-response", message, options);
    this.name = "AdapterValidationError";
  }
}

export class AdapterDatabaseError extends MarketDataAdapterError {
  constructor(message: string, options?: ErrorOptions) {
    super("database-error", message, options);
    this.name = "AdapterDatabaseError";
  }
}
